document.addEventListener("DOMContentLoaded", () => {
    function animateCounter(counter) {
        const target = parseInt(counter.getAttribute('data-target'));
        const duration = 700;
        const increment = (target / duration) * 10;
        let currentValue = 0;

        counter.style.opacity = '1';

        const updateCounter = () => {
            currentValue += increment;

            const formattedValue = Math.round(currentValue).toString().padStart(2, '0');
            counter.textContent = formattedValue;

            if (currentValue < target) {
                requestAnimationFrame(updateCounter);
            } else {
                counter.classList.add('animated');
            }
        };

        updateCounter();
    }

    const options = {
        threshold: 0.2
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && window.innerWidth >= 768) {
                const counterElement = entry.target;
                if (!counterElement.classList.contains('animated')) {
                    animateCounter(counterElement);
                }
            }
        });
    }, options);

    const counters = document.querySelectorAll('.js-accordion-counter');
    counters.forEach(counter => {
        observer.observe(counter);
    });
});
